import React from 'react';
import AdvWorkflow from '../../../AdvWorkflow/AdvWorkflowContainer';
import Age from '../../../PersonalInfoWorkflow/Steps/AgeContainer';

interface Props {
  branch: number[];
  workflowId: string;
}

export const PersonalInfoWorkflow = ({ branch, workflowId }: Props) => (
  <AdvWorkflow branch={branch} workflowId={workflowId} steps={[Age]} />
);
